import Vue from 'vue'
//lib para conversão de datas
window.moment = require('moment');
window.moment.locale('pt-br');

var VueTruncate = require('vue-truncate-filter')
Vue.use(VueTruncate)

Vue.filter('inputClassErro', function(erro){
	return  erro ? 'form-group has-error has-feedback' :  'form-group has-feedback'
})

function dataComReferencia(date, formatoData, formatoHora = '') {
  if (!date) {
    return ''
  }

  const valor = moment(date)
  if (!valor.isValid()) {
    return ''
  }

  const hoje = moment()
  let dataFormatada = valor.format(formatoData)
  if (valor.isSame(hoje, 'day')) {
    dataFormatada = 'Hoje'
  } else if (valor.isSame(hoje.clone().add(1, 'day'), 'day')) {
    dataFormatada = 'Amanhã'
  } else if (valor.isSame(hoje.clone().subtract(1, 'day'), 'day')) {
    dataFormatada = 'Ontem'
  }

  return formatoHora ? `${dataFormatada}, ${valor.format(formatoHora)}` : dataFormatada
}

Vue.filter('data', function(date){
  return dataComReferencia(date, 'DD-MM-YYYY')
})

Vue.filter('dataHora', function(date){
  return dataComReferencia(date, 'DD-MM-YYYY', 'HH:mm:ss')
})

Vue.filter('dataHoraCurta', function(date){
  return dataComReferencia(date, 'DD-MM-YYYY', 'HH:mm')
})

Vue.filter('hora', function(date){
  if (date) {
    return moment(date).format('HH:mm')
  }
  return ''
})

// setar prefixo em url [parametro 'prefixo da url']
Vue.filter('urlPrefix', function(url, prefix){
      return prefix + url
})

Vue.filter('removeUnderlineText', function (value) {
  return  value.replace(/_/g, " ")
})

Vue.filter('classIcoP', function(value){

    let ico = ''
    switch (value) {
      case 'pdf':
        ico = 'fa-file-pdf-o text-danger'
        break;
      case 'doc':
      case 'docx':
        ico = 'fa-file-word-o text-primary'
        break;
      case 'txt':
        ico = 'fa-file-text-o img-ico-anexo'
        break;
      case 'jpg':
      case 'png':
      case 'jpeg':
        ico = 'fa-file-image-o'
        break;
      default:

    }
    return 'fa ' + ico
})
